import { render, staticRenderFns } from "./ReportInstructivoEmbarqueAereo.vue?vue&type=template&id=160f4bd7"
import script from "./ReportInstructivoEmbarqueAereo.vue?vue&type=script&lang=js"
export * from "./ReportInstructivoEmbarqueAereo.vue?vue&type=script&lang=js"
import style0 from "./ReportInstructivoEmbarqueAereo.vue?vue&type=style&index=0&id=160f4bd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports